export default __webpack_public_path__ + "static/media/Aseel.ec5eaf9c.jpg";